import { apiClient } from "rp-components"
import { WorkflowDocument } from "rp-components"
import { MaintenanceTicket } from "rp-components"
import { MaintenanceTicketStatus as TicketStatus, MaintenanceTicketAction } from "rp-components"
import { Page } from "rp-components"

export interface MaintenanceService {
    listTickets(propertyId: number, statuses: string[], minPageSize: number, offset?: number): Promise<Page<MaintenanceTicket[]>>
    getTicket(propertyId: number, ticketId: string): Promise<MaintenanceTicket>
    listStatuses(propertyId: number): Promise<TicketStatus[]>
    listTicketTypes(propertyId: number): Promise<string[]>
    listNotificationOptions(propertyId: number): Promise<string[]>
    saveTicket(ticket: MaintenanceTicket): Promise<MaintenanceTicket>
    createComment(propertyId: number, action: MaintenanceTicketAction): Promise<MaintenanceTicketAction>
    performAction(propertyId: number, action: MaintenanceTicketAction): Promise<MaintenanceTicket>
    getOpenWorkflowsForTicket(propertyId: string, ticketId: string): Promise<WorkflowDocument[]>
}

class MaintenanceServiceImpl implements MaintenanceService {
    static instance?: MaintenanceService = undefined

    private constructor() {}

    static getInstance(): MaintenanceService {
        if (MaintenanceServiceImpl.instance == undefined) {
            MaintenanceServiceImpl.instance = new MaintenanceServiceImpl()
        }
        return MaintenanceServiceImpl.instance
    }

    async listTickets(propertyId: number, statuses: string[], minPageSize: number, offset?: number): Promise<Page<MaintenanceTicket[]>> {
        const params = {
            statuses,
            minPageSize,
            offset
        }
        const ticketsPage = await apiClient.getPage<MaintenanceTicket[]>(`/properties/${propertyId}/maintenance/tickets`, params)
        return ticketsPage
    }

    async getTicket(propertyId: number, ticketId: string): Promise<MaintenanceTicket> {
        return await apiClient.get(`/properties/${propertyId}/maintenance/tickets/${ticketId}`)
    }

    async listStatuses(propertyId: number): Promise<TicketStatus[]> {
        return await apiClient.get<TicketStatus[]>(`properties/${propertyId}/maintenance/tickets/statuses`)
    }

    async listTicketTypes(propertyId: number): Promise<string[]> {
        return await apiClient.get<string[]>(`properties/${propertyId}/maintenance/tickets/types`)
    }

    async listNotificationOptions(propertyId: number): Promise<string[]> {
        return await apiClient.get<string[]>(`properties/${propertyId}/maintenance/tickets/notificationOptions`)
    }

    async saveTicket(ticket: MaintenanceTicket): Promise<MaintenanceTicket> {
        return await apiClient.post<MaintenanceTicket, MaintenanceTicket>(`properties/${ticket.propertyId}/maintenance/tickets`, ticket)
    }

    async createComment(propertyId: number, action: MaintenanceTicketAction): Promise<MaintenanceTicketAction> {
        return await apiClient.post<MaintenanceTicketAction, MaintenanceTicketAction>(
            `properties/${propertyId}/maintenance/tickets/${action.ticketId!}/comments`,
            action
        )
    }

    async performAction(propertyId: number, action: MaintenanceTicketAction): Promise<MaintenanceTicket> {
        return await apiClient.post<MaintenanceTicket, MaintenanceTicketAction>(
            `properties/${propertyId}/maintenance/tickets/${action.ticketId!}/actions`,
            action
        )
    }

    async getOpenWorkflowsForTicket(propertyId: string, ticketId: string): Promise<WorkflowDocument[]> {
        return await apiClient.get(`properties/${propertyId}/maintenance/tickets/${ticketId}/workflows`)
    }
}

export default MaintenanceServiceImpl.getInstance()
